// extracted by mini-css-extract-plugin
module.exports = {"left":"uitgangspunten_left__3802c","right":"uitgangspunten_right__3Wb1q","padding_left":"uitgangspunten_padding_left__Lmjgi","datagrid":"uitgangspunten_datagrid__2KmB5"};